import { normalizeFilters } from "../../../shared/lib/normalizeFilters";
import type { PushAdminUsersFilters, PushMessageListFilters } from "@myapp/contract";

export const notificationKeys = {
  all: ["notifications"] as const,
  vapidKey: () => [...notificationKeys.all, "vapid-key"] as const,
  devices: () => [...notificationKeys.all, "devices"] as const,
  adminUsers: (filters?: PushAdminUsersFilters) =>
    [...notificationKeys.all, "admin-users", normalizeFilters(filters)] as const,
  adminStats: () => [...notificationKeys.all, "admin-stats"] as const,
  messages: (filters?: PushMessageListFilters) =>
    [...notificationKeys.all, "messages", normalizeFilters(filters)] as const,
};
